import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/mp-tips-arrow.png'
import _imports_1 from '../assets/images/ibook-logo-ico.png'
import _imports_2 from '../assets/images/ibook-logo-font.png'
import _imports_3 from '../assets/images/tal-logo.png'


const _hoisted_1 = { class: "result-container pb" }
const _hoisted_2 = { class: "mp-tips" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "点击右上角按钮，然后在弹出的菜单中，点击在浏览器中打开，即可安装", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { title: "好未来图书" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "ibook-logo-ico"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "ibook-logo-font"
  })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "about-app" }, " 学而思图书正式更名为好未来图书，好未来图书App是好未来旗下专注于为中小学生提供含教辅、读物、绘本、智能学+等多元化图书产品。致力于成为中小学生一站式选书用书平台。 ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "tal-logo"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "download-copyright" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Copyright@欣欣相融教育科技（深圳）有限公司"),
  /*#__PURE__*/_createElementVNode("p", null, "粤ICP备18040912号-6"),
  /*#__PURE__*/_createElementVNode("p", null, "北京新唐思创教育科技有限公司")
], -1)

import { ref, onMounted, inject } from 'vue'
import { useRoute } from 'vue-router'
import { getVersionInfo } from '@/api/aio'
import { isIOS } from '@/assets/js/utils'

export default /*#__PURE__*/_defineComponent({
  __name: 'Download',
  setup(__props) {

const downloadUrl = ref('')
const isWechat = ref(false)
const $xesLog = inject('$xesLog') as any // 埋点
const route = useRoute()
const queryBookseries = route.query.bookseries || ''
// pv埋点
const xesLogPv = () => {
  $xesLog.track('pv_download_blank_blank', {
    page_name: 'download',
    event_type: 'pv',
    event_name: '引导下载页pv',
    content: window.location.href,
    bookseries: queryBookseries
  })
}
const downloadHandler = () => {
  $xesLog.track('click_download_blank_blank', {
    page_name: 'download',
    event_type: 'click',
    button_name: '立即下载',
    event_name: '点击下载客户端',
    content: window.location.href,
    bookseries: queryBookseries
  })
  location.href = downloadUrl.value
}
onMounted(() => {
  xesLogPv()
  downloadUrl.value = isIOS()
    ? 'https://itunes.apple.com/cn/app/id1603417342?l=zh&ls=1&mt=8'
    : 'https://sj.qq.com/appdetail/com.tal.publish.book'
  isWechat.value = /micromessenger/.test(navigator.userAgent.toLowerCase())
  getVersionInfo().then((res) => {
    if (res.data.code !== 0) {
      return
    }
    if (isIOS()) {
      downloadUrl.value = res.data?.data?.update?.itunes_url
    } else {
      downloadUrl.value = res.data?.data?.update?.file_path_url
    }
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, _hoisted_5, 512), [
      [_vShow, isWechat.value]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["container", { 'mp-container': isWechat.value }])
    }, [
      _hoisted_6,
      _hoisted_7,
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (downloadHandler())),
        class: "download-btn"
      }),
      _hoisted_8,
      _hoisted_9
    ], 2)
  ]))
}
}

})